<p mat-dialog-title class="custom-title">App installieren</p>
<mat-dialog-content class="mat-typography">
    @if (!appIsInstallable) {
        <p class="custom-body-small">Ihre Browsereinstellungen verhindern das Herunterladen dieser Webseite als App. Bitte überprüfen Sie Ihre Browsereinstellungen.</p>
    }
    @else {
        <p class="custom-body-small">Sofern Sie die App noch nicht installiert haben, befolgen Sie bitte die folgenden Schritte.</p>
        @if (notification) {
            <p class="custom-body-small notification">{{notification}}</p>
        }
        <mat-stepper orientation="horizontal" [linear]="false" #stepper>
        @for (step of steps; track step; let first = $first; let last = $last) {
            <mat-step>
            <!-- <ng-template matStepLabel>{{ step.name }}</ng-template> -->
             @if (step.message) {
                <p class="custom-body-small">{{step.message}}</p>
             }
            <div class="step-image">
                <img [src]="step.image" [alt]="step.name" style="max-width: 100%; max-height: 300px; height: 100%; width: auto;"/>
            </div>
            <div>
                @if (!$first) {
                    <button mat-button matStepperPrevious>Zurück</button>
                  }
                  @if (!$last) {
                    <button mat-button matStepperNext>Weiter</button>
                  }
            </div>
            </mat-step>
        }    
        </mat-stepper>
    }
</mat-dialog-content>

